import React from 'react';
import { useSelector } from 'react-redux';

// Packages
import { Button, Flex, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotAuth = () => {	
	const navigate = useNavigate();

	const { global_data } = useSelector(state => state.global);

	const goBack = () => {
		navigate(-2);
	}

	return (
		<Flex vertical align='center' justify='center' style={{ height: '90vh' }}>
			<Result
				status='403'
				title='401'
				subTitle={global_data?.utils?.unauthorizedPageMsg}
				extra={<Button type='primary' onClick={goBack}>{global_data?.actionButtons?.back}</Button>}
			/>
		</Flex>
	)
}

export default NotAuth;
